import './EditPackageDetails.scss';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Error from '../Error/Error';
import Checkbox from '../Checkbox/Checkbox';
import Packages from '../../api/controllers/Packages/Packages';
import Job from '../../api/controllers/Job/Job';

// EditPackageDetails Component
const EditPackageDetails = ({ packages, setModalOpen, refetchPackages }) => {
  const [quantity, setQuantity] = useState();
  const [weight, setWeight] = useState();
  const [length, setLength] = useState();
  const [width, setWidth] = useState();
  const [height, setHeight] = useState();

  const [verified, setVerified] = useState(true);
  const [damaged, setDamaged] = useState(false);
  const [error, setError] = useState();

  const [expected, setExpected] = useState({
    quantity: 'Expected: ',
    weight: 'Expected: ',
    length: 'Expected: ',
    height: 'Expected: ',
    width: 'Expected: ',
  });

  const getExpectedDetails = () => {
    Job.show(packages[0]?.package.job.id)
      .then(response => {
        setExpected({
          quantity: `Expected: ${
            response.quantity
              ? `${response.quantity} Package${response.quantity > 1 ? 's' : ''}`
              : 'Not Specified'
          }`,
          weight: `Expected: ${
            response.grossWeightKg ? `${response.grossWeightKg} kg` : 'Not Specified'
          }`,
          length:
            response.dimensionsLines
              .map(line => line.lengthCm)
              .every(length => length == response.dimensionsLines.map(line => line.lengthCm)[0]) &&
            response.dimensionsLines.map(line => line.lengthCm)[0] != null
              ? `Expected: ${response.dimensionsLines.map(line => line.lengthCm)[0]} cm`
              : response.dimensionsLines.map(line => line.lengthCm)[0] != null
              ? 'Expected: Various'
              : 'Expected: Not Specified',
          height:
            response.dimensionsLines
              .map(line => line.heightCm)
              .every(length => length == response.dimensionsLines.map(line => line.heightCm)[0]) &&
            response.dimensionsLines.map(line => line.heightCm)[0] != null
              ? `Expected: ${response.dimensionsLines.map(line => line.heightCm)[0]} cm`
              : response.dimensionsLines.map(line => line.heightCm)[0] != null
              ? 'Expected: Various'
              : 'Expected: Not Specified',
          width:
            response.dimensionsLines
              .map(line => line.widthCm)
              .every(length => length == response.dimensionsLines.map(line => line.widthCm)[0]) &&
            response.dimensionsLines.map(line => line.widthCm)[0] != null
              ? `Expected: ${response.dimensionsLines.map(line => line.widthCm)[0]} cm`
              : response.dimensionsLines.map(line => line.widthCm)[0] != null
              ? 'Expected: Various'
              : 'Expected: Not Specified',
        });
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    getExpectedDetails();
    const currentQuantity =
      packages
        .map(p => p.package.quantity)
        .every(quantity => quantity == packages.map(p => p.package.quantity)) &&
      packages.map(p => p.package.quantity)[0] != null
        ? packages.map(p => p.package.quantity)[0]
        : '';
    setQuantity(currentQuantity);

    const currentWeight =
      packages
        .map(p => p.package.grossWeightKg)
        .every(weight => weight == packages.map(p => p.package.grossWeightKg)) &&
      packages.map(p => p.package.grossWeightKg)[0] != null
        ? packages.map(p => p.package.grossWeightKg)[0]
        : '';
    setWeight(currentWeight);

    const currentLength =
      packages
        .map(p => p.package.lengthCm)
        .every(length => length == packages.map(p => p.package.lengthCm)) &&
      packages.map(p => p.package.lengthCm)[0] != null
        ? packages.map(p => p.package.lengthCm)[0]
        : '';
    setLength(currentLength);

    const currentWidth =
      packages
        .map(p => p.package.widthCm)
        .every(width => width == packages.map(p => p.package.widthCm)) &&
      packages.map(p => p.package.widthCm)[0] != null
        ? packages.map(p => p.package.widthCm)[0]
        : '';
    setWidth(currentWidth);

    const currentHeight =
      packages
        .map(p => p.package.heightCm)
        .every(height => height == packages.map(p => p.package.heightCm)) &&
      packages.map(p => p.package.heightCm)[0] != null
        ? packages.map(p => p.package.heightCm)[0]
        : '';
    setHeight(currentHeight);
  }, []);

  const updatePackageDetails = () => {
    const ids = packages.map(p => p.package.id);
    const data = {
      quantity: quantity || null,
      grossWeightKg: weight || null,
      lengthCm: length || null,
      widthCm: width || null,
      heightCm: height || null,
      verified: verified,
      damaged: damaged,
    };

    Packages.update(ids, data)
      .then(() => {
        refetchPackages();
        setModalOpen(false);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  return (
    <div className="edit_package_details_container">
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${
                  error.length > 1 ? 's' : ''
                } prohibited this item from being saved: `
              : ''
          }
        />
      )}
      <div className="affected_packages">
        {packages.length > 0 &&
          `This action applies to ${
            packages.length > 3
              ? `${packages.length} packages`
              : `${packages[0].packageName}${
                  packages[1]
                    ? `${packages.length > 2 ? ',' : ' and'} ${packages[1].packageName}`
                    : ''
                }${packages[2] ? ` and ${packages[2].packageName}` : ''}`
          } `}
      </div>
      <form className="details_form">
        <div className="form_rows">
          <div className="detail_row">
            <div className="label">Quantity</div>
            <input
              placeholder={expected.quantity}
              value={quantity}
              onChange={e => setQuantity(e.target.value)}
              type={'number'}
            />
          </div>
          <div className="detail_row">
            <div className="label">Weight (kg)</div>
            <input
              placeholder={expected.weight}
              value={weight}
              onChange={e => setWeight(e.target.value)}
              type={'number'}
            />
          </div>
          <div className="detail_row">
            <div className="label">Length (cm)</div>
            <input
              placeholder={expected.length}
              value={length}
              onChange={e => setLength(e.target.value)}
              type={'number'}
            />
          </div>
          <div className="detail_row">
            <div className="label">Width (cm)</div>
            <input
              placeholder={expected.width}
              value={width}
              onChange={e => setWidth(e.target.value)}
              type={'number'}
            />
          </div>
          <div className="detail_row">
            <div className="label">Height (cm)</div>
            <input
              placeholder={expected.height}
              value={height}
              onChange={e => setHeight(e.target.value)}
              type={'number'}
            />
          </div>
        </div>
        <div className="form_buttons">
          <div className="form_checkbox">
            <Checkbox
              selected={verified}
              handleClick={() => setVerified(!verified)}
              label="details_verified"
            />{' '}
            Verified?
          </div>
          <div className="form_checkbox">
            <Checkbox
              selected={damaged}
              handleClick={() => setDamaged(!damaged)}
              label="details_damaged"
            />{' '}
            Damaged?
          </div>
          <div className="update_button" onClick={() => updatePackageDetails('')}>
            Update
          </div>
        </div>
      </form>
    </div>
  );
};

EditPackageDetails.propTypes = {
  packages: PropTypes.array,
  setModalOpen: PropTypes.func,
  refetchPackages: PropTypes.func,
};

export default EditPackageDetails;
